import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import { GetPartnerByIdResponse, GetPartnersResponse, PutPartnerResponse } from '../response/partner';
import { CreatePartnerPayload, UpdatePartnerPayload } from '../request/partner';

export class PartnerService {
  static getPartners(params?: QueryParams) {
    return apiClient.get<GetPartnersResponse>(buildApiUrl('/api/v1/partners/partner'), params);
  }

  static createPartner(payload: CreatePartnerPayload) {
    return apiClient.createWithFile<void>(buildApiUrl('/api/v1/partners/partner'), payload);
  }

  static getPartnerById(id: string, params?: QueryParams) {
    return apiClient.get<GetPartnerByIdResponse>(buildApiUrl('/api/v1/partners/partner/:id', { id }), params);
  }

  static putPartner(id: string, payload: UpdatePartnerPayload) {
    return apiClient.updateWithFile<PutPartnerResponse>(buildApiUrl('/api/v1/partners/partner/:id', { id }), payload);
  }

  static deletePartnerById(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/partners/partner/:id', { id }));
  }
}
